import { APPLICATION_CONSTANTS } from '@translations/constants/app.constants';

export const APPLICATION_ROUTES = {
  NOT_FOUND: '/404',
  ACCESS_DENIED: '/403',
  DASHBOARD: `${APPLICATION_CONSTANTS.APPLICATION_ROOT_URL}`,
  HOME: `${APPLICATION_CONSTANTS.APPLICATION_ROOT_URL}`,
  LOGIN: '/login',
};
